import TreeExample from "./examples/Tree.Example";
import TreeManyItemsExample from "./examples/Tree.ManyItems.Example";

export default [
    {
        title: "Basic tree",
        component: TreeExample,
        code: require("!raw-loader!./examples/Tree.Example.tsx"),
        dependencies: {
            "TreeData.ts": require("!raw-loader!./examples/TreeData.ts")
        }
    },
    {
        title: "Tree with many items",
        component: TreeManyItemsExample,
        code: require("!raw-loader!./examples/Tree.ManyItems.Example.tsx"),
        dependencies: {
            "TreeData.ts": require("!raw-loader!./examples/TreeData.ts")
        }
    }
];
